import React, { useState } from "react";
import cn from "classnames";
import style from "./Draft.module.sass";
import Card from "../Card";
import collection from "../../i11/Collection";
import { useUser } from "../../context";
import Modal from "../Modal";
import Confirm from "../Confirm";
import product from "../../i11/Product";
import { baseUrl, editorConfig } from "../Editor";
import JoditEditor from "jodit-react";

const RichEditor = ({
	data,
	setData,
	onClose,
	closeConfirm,
	isOpenConfirm,
}) => {
	//#region States & refs
	const [editorState, setEditorState] = useState(data);
	let uploadFile, isSuccessData, content;

	const {
		tokens: { access_token },
		brand,
		locale,
	} = useUser();

	const onConfirm = () => {
		setData(content || editorState);
		onClose();
	};

	const config = {
		...editorConfig,
		uploader: {
			imagesExtensions: ["jpg", "png", "jpeg", "gif"],
			insertImageAsBase64URI: false,
			url: `${baseUrl}/v1/image?miniSize=NO&whereFolder=BRANDS`,
			headers: {
				// "Content-Type": "multipart/form-data; boundary=*", //boundary=----WebKitFormBoundary8AXvPJxYK4RnTe00
				Authorization: `Bearer ${access_token}`,
				"x-brand": brand?._id,
				Accept: "*/*",
			},
			method: "POST",
			format: "file",

			processFileName: (key, file, name) => {
				uploadFile = file;
				return [key, file, name];
			},

			buildData: () => {
				const formData = new FormData();
				formData.append("image", uploadFile);
				return formData;
			},
			prepareData: function (formdata) {
				formdata.append("image", uploadFile);
			},
			isSuccess: function (resp, data) {
				isSuccessData = resp;
				return resp?.core_image_url;
			},
			getMessage: function (resp, data) {
				return resp.msg;
			},
			defaultHandlerSuccess: function (resp, data) {
				if (isSuccessData?.success === false) return;
				if (isSuccessData)
					this.s.insertImage(isSuccessData?.core_image_url);
			},

			error: function (e) {
				this.message.message(e.getMessage(), "error", 4000);
			},
		},
	};
	return (
		<>
			<Card
				title={collection[locale].detailed_description}
				classTitle={cn("title-green")}
				className={style.editor}
			>
				<JoditEditor
					className={style.editorMain}
					value={editorState}
					config={config}
					onChange={(val) => (content = val)}
				/>
				{/* <JoditEditorD content={editorState} setContent={handleChange} /> */}
				<div className={style.foot}>
					<button onClick={onConfirm} className="button">
						{collection[locale].confirm}
					</button>
				</div>
			</Card>
			<Modal visible={isOpenConfirm} onClose={closeConfirm}>
				<Confirm
					title={product[locale].detailed_desc}
					note={product[locale].draft_confirmation}
					onCancel={closeConfirm}
					onConfirm={onClose}
				/>
			</Modal>
		</>
	);
};

export default RichEditor;
